module.exports = __webpack_public_path__ + "img/card-select-type-eat-in-icon_tenpo.62e72693.svg";